import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "@/api/core";
import { useApi } from "@/hooks";
import { predictionChartSchema, PredictionStatus } from "@/schemas/prediction";
import { filteredArray } from "@/schemas/utils";

import { usePrediction } from "./usePrediction";

type Params = {
  isEnabled?: boolean;
  limit?: number;
  contract_types?: string[];
};

function usePredictionChart(status: PredictionStatus, params: Params) {
  const { isEnabled = true, ...chartParams } = params;
  const api = useApi();
  const { poolingInterval } = usePrediction(status.id, { isEnabled });

  async function getPredictionChart() {
    const { data } = await api.get(
      `/api/v1/predictions/events/${status.prediction.id}/graph`,
      {
        params: chartParams,
      },
    );
    const charts = filteredArray(predictionChartSchema).parse(data);
    return charts;
  }

  const queryInfo = useQuery({
    queryFn: getPredictionChart,
    queryKey: QueryKeys.predictions.chart(status.prediction.id),
    enabled: isEnabled,
    refetchInterval: () => {
      if (poolingInterval === -1) return false;
      return poolingInterval * 1000;
    },
  });

  return {
    chart: queryInfo.data || [],
    ...queryInfo,
  };
}

export { usePredictionChart };
